const ASSETS = "https://pkrhires.com/email";

const SOCIAL_ICONS = [
  { id: "linkedin", icon: `${ASSETS}/linkedin.png`, alt: "LinkedIn" },
  { id: "instagram", icon: `${ASSETS}/instagram.png`, alt: "Instagram" },
  { id: "facebook", icon: `${ASSETS}/facebook.png`, alt: "Facebook" },
];

const esc = (s) => String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

const contactRow = (icon, alt, href, text) =>
  `<tr><td style="padding:0 0 6px 0;vertical-align:middle"><img src="${icon}" width="16" height="16" alt="${alt}" style="display:inline-block;vertical-align:middle;margin-right:8px;border:0" /><a href="${href}" style="color:#1B3A6B;text-decoration:none;font-size:13px;vertical-align:middle">${text}</a></td></tr>`;

export const buildSignatureHtml = (f) => {
  const rows = [
    f.phone && contactRow(`${ASSETS}/phone.png`, "Phone", `tel:${f.phone.replace(/[^\d+]/g, "")}`, esc(f.phone)),
    f.email && contactRow(`${ASSETS}/email.png`, "Email", `mailto:${esc(f.email)}`, esc(f.email)),
    f.website && contactRow(`${ASSETS}/web.png`, "Website", `https://${esc(f.website.replace(/^https?:\/\//, ""))}`, esc(f.website.replace(/^https?:\/\//, ""))),
  ]
    .filter(Boolean)
    .join("");
  const socials = SOCIAL_ICONS.filter((s) => f[s.id])
    .map((s) => `<a href="${esc(f[s.id])}" style="display:inline-block;margin-right:10px"><img src="${s.icon}" width="22" height="22" alt="${s.alt}" style="display:block;border:0" /></a>`)
    .join("");
  return `<table cellpadding="0" cellspacing="0" border="0" style="font-family:Arial,Helvetica,sans-serif;color:#111111;border-collapse:collapse">
  <tr>
    <td style="padding:0 20px 0 0;border-right:2px solid #1B3A6B;vertical-align:top">
      <a href="https://pkrhires.com" style="text-decoration:none"><img src="${ASSETS}/pkr-logo.png" width="120" alt="PKR Recruiting" style="display:block;border:0" /></a>
    </td>
    <td style="padding:0 0 0 20px;vertical-align:top">
      <p style="margin:0 0 2px 0;font-size:17px;font-weight:bold;color:#0E2140">${esc(f.name)}</p>
      <p style="margin:0 0 10px 0;font-size:13px;color:#555555">${esc(f.title)}${f.title && f.company ? " &nbsp;|&nbsp; " : ""}${esc(f.company)}</p>
      <table cellpadding="0" cellspacing="0" border="0" style="border-collapse:collapse">${rows}</table>
      ${socials ? `<p style="margin:10px 0 0 0">${socials}</p>` : ""}
    </td>
  </tr>
</table>`;
};
